import { __ } from "@wordpress/i18n";
import domReady from "@wordpress/dom-ready";
import { createRoot } from "@wordpress/element";
import TestimonialsSlider from "./TestimonialsSlider";

domReady(() => {
	const mountElement = document.querySelectorAll(
		".wp-block-qasas-companion-testimonials-slider",
	);
	const mountElementArr = Array.from(mountElement);

	mountElementArr.forEach((item) => {
		if (createRoot) {
			createRoot(item).render(
				<TestimonialsSlider
					testimonials={JSON.parse(
						item.getAttribute("data-block-testimonials"),
					)}
				/>,
			);
		}
	});
});
